var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSex = function SvgSex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 592 592"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313030",
    d: "M294.832 10.31C135.312 10.31 6 139.621 6 299.137c0 159.517 129.312 288.785 288.832 288.785s288.831-129.268 288.831-288.785c0-159.516-129.312-288.827-288.831-288.827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 13.323,
    d: "M296.153 7C136.63 7 7.318 136.311 7.318 295.825c0 159.518 129.312 288.788 288.835 288.788 159.517 0 288.831-129.27 288.831-288.788C584.984 136.311 455.67 7 296.153 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M148.654 321.051c0-53.855 43.652-97.507 97.506-97.507s97.506 43.652 97.506 97.507c0 53.839-43.653 97.492-97.506 97.492s-97.506-43.653-97.506-97.492m40.012 0c0 31.745 25.747 57.492 57.494 57.492 31.748 0 57.494-25.747 57.494-57.492 0-31.761-25.746-57.493-57.494-57.493-31.747 0-57.494 25.732-57.494 57.493",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M211.305 256.449c0-53.839 43.653-97.492 97.508-97.492 53.852 0 97.493 43.653 97.493 97.492 0 53.855-43.641 97.508-97.493 97.508-53.855 0-97.508-43.653-97.508-97.508m40.014 0c0 31.761 25.732 57.495 57.494 57.495 31.745 0 57.493-25.734 57.493-57.495 0-31.745-25.748-57.492-57.493-57.492-31.762 0-57.494 25.747-57.494 57.492M225.348 529.369h42.346v-135h-42.346z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M195.945 490.891h101.379v-42.349H195.945zM418.307 118.156l29.906 29.986-82.64 82.428-29.907-29.986z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M426.146 202.912h34.847v-97.501h-34.847z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M363.479 140.26h97.5v-34.848h-97.5z",
    clipRule: "evenodd"
  })));
};
export default SvgSex;